import React from 'react';
import { arrowConfig } from '../../../data/paint-modals';

export const DoubleSidedArrow = () => (
  <div className="sui-relative sui-flex sui-items-center sui-justify-center sui-mt-[5px] sui-mx-[2%] sui-mb-0"
  >
    <div
      className="sui-w-0 sui-h-0"
      style={{
        borderRight: `${arrowConfig.WIDTH}px solid ${arrowConfig.LEFT_COLOR}`,
        borderTop: `${arrowConfig.HEIGHT}px solid transparent`,
        borderBottom: `${arrowConfig.HEIGHT}px solid transparent`
      }}
    ></div>
    <div
      className="sui-h-4 sui-w-[90%]"
      style={{
        backgroundColor: `${arrowConfig.BACKGROUND}`,
        background: `linear-gradient(90deg,${arrowConfig.LEFT_COLOR},${arrowConfig.RIGHT_COLOR})`,
        height: `${arrowConfig.GRADIENT_HEIGHT}px`,
      }}
    ></div>
    <div
      className="sui-w-0 sui-h-0"
      style={{
        borderLeft: `${arrowConfig.WIDTH}px solid ${arrowConfig.RIGHT_COLOR}`,
        borderTop: `${arrowConfig.HEIGHT}px solid transparent`,
        borderBottom: `${arrowConfig.HEIGHT}px solid transparent`
      }}
    ></div>
  </div>
);